<template>
    <b-modal
        :id="modalId"
        ref="modal"
        :title="modalTitle"
        size="lg"
        cancel-variant="light"
        ok-variant="primary"
        :cancel-title="$t('cancel')"
        :ok-title="$t('save')"
        :busy="loading"
        static
        @ok.prevent="formSubmit()"
        @show="resetFormData()"
        @hidden="resetFormData()"
    >
        <b-overlay :show="loading" opacity="0" class="h-100">
            <b-form @submit.prevent>
                <FormValidator :validator="$v.form.price" form-group v-slot="slotProps" :label="$t('price')">
                    <b-form-input v-model="form.price" :placeholder="$t('price')" :state="slotProps.state" :disabled="loading" />
                </FormValidator>
            </b-form>
        </b-overlay>
    </b-modal>
</template>



<script>
    import { required } from 'vuelidate/lib/validators';
    import FormValidator from '@/components/common/FormValidator.vue';
    import formBackendValidationMixin from '@/mixins/formBackendValidationMixin';
    import cloneDeep from 'lodash/cloneDeep';
    import { deepMergeWithFilter } from '@/utils/util';

    const FORM_DEFAULT_DATA = Object.freeze({
        name: '',
        price: '',
    });

    export default {
        name: 'ModalEditRecommendedPrice',
        mixins: [formBackendValidationMixin],
        components: {
            FormValidator,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.parentComponent.requestUpdatePrice,
                modalId: 'modal-edit-recommended-price',
                item: null,
                form: cloneDeep(FORM_DEFAULT_DATA),
            };
        },
        computed: {
            modalTitle() {
                return `Edycja ceny produktu "${this.item?.name}"`;
            },
            formValidations() {
                return {
                    form: {
                        name: { required },
                        price: { required },
                    },
                };
            },
            loading() {
                return this.request.getLoading(this.item?.id);
            },
        },
        methods: {
            initItem(item) {
                this.item = item;
            },
            resetFormData() {
                this.form = cloneDeep(FORM_DEFAULT_DATA);
                this.$v.form.$reset();
            },
            initFormData() {
                this.form = deepMergeWithFilter(FORM_DEFAULT_DATA, this.item);
            },
            onInit(item) {
                this.initItem(item);
                this.resetFormData();
                this.initFormData();
            },
            formSubmit() {
                this.$v.form.$touch();
                if (this.$v.form.$invalid) {
                    return;
                }
                const apiParams = {
                    urlParams: { id: this.item.id },
                    requestParams: this.form,
                };
                this.request
                    .id(this.item.id)
                    .patch(apiParams)
                    .then(item => {
                        this.$toastr.success(this.$t('dataSavedSuccessfully'));
                        this.$refs.modal.hide();
                        const data = this.parentComponent.request.getData();
                        this.$set(data.products[item.id].product, 'price', item.price);
                    })
                    .catch(this.handleBackendValidations);
            },
        },
        mounted() {
            this.$root.$on(this.modalId, this.onInit);
        },
        beforeDestroy() {
            this.$root.$off(this.modalId, this.onInit);
        },
    };
</script>
